// App.js
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { DashboardProvider } from './DashboardContext';
import { ThemeProvider } from './ThemeContext';
import Login from './Login';
import Register from './Register';
import PrivateRoute from './PrivateRoute';
import Admin from './Admin';
import SidebarLayout from './SidebarLayout';
import InternalReport from './InternalReports';
import PermissionGuard from "./PermissionGuard";
import ExFacDashboard from './ExFacDashboard';
import EmployeeDashboard from './EmployeeDashboard';
import GPDashboardChat from './GPDashboardChat';
import DataConfiguration from './DataConfiguration';
import HospitalAIDashboard from './HospitalAIDashboard';
import RxAIDashboard from './RxAIDashboard';

function App() {
  return (
    <Router>
      <DashboardProvider>
        <AuthProvider>
          <ThemeProvider>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route
                  path="/dashboard"
                  element={
                    <PrivateRoute>
                      <SidebarLayout>
                        <PermissionGuard permission="view_hospital_dashboard">
                          <RxAIDashboard />
                        </PermissionGuard>
                      </SidebarLayout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/gp-rx-dashboard"
                  element={
                    <PrivateRoute>
                      <SidebarLayout>
                        <PermissionGuard permission="view_dashboard">
                          <GPDashboardChat />
                        </PermissionGuard>
                      </SidebarLayout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/ex-fac-dashboard"
                  element={
                    <PrivateRoute>
                      <SidebarLayout>
                        <PermissionGuard permission="view_exfac_dashboard">
                          <ExFacDashboard />
                        </PermissionGuard>
                      </SidebarLayout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/hospital-dashboard"
                  element={
                    <PrivateRoute>
                      <SidebarLayout>
                        <PermissionGuard permission="view_hospital_dashboard">
                          <HospitalAIDashboard />
                        </PermissionGuard>
                      </SidebarLayout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/employee-dashboard"
                  element={
                    <PrivateRoute>
                      <SidebarLayout>
                        <PermissionGuard permission="view_dashboard">
                          <EmployeeDashboard />
                        </PermissionGuard>
                      </SidebarLayout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/internal-reports-configuration"
                  element={
                    <PrivateRoute>
                      <SidebarLayout>
                        <PermissionGuard permission="view_internal_reports_configuration">
                          <DataConfiguration />
                        </PermissionGuard>
                      </SidebarLayout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/internal-reports"
                  element={
                    <PrivateRoute>
                      <SidebarLayout>
                        <PermissionGuard permission="view_internal_reports">
                          <InternalReport />
                        </PermissionGuard>
                      </SidebarLayout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <PrivateRoute adminRequired={true}>
                      <SidebarLayout>
                        <Admin />
                      </SidebarLayout>
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/"
                  element={
                    <PrivateRoute>
                      <SidebarLayout>
                        <GPDashboardChat />
                      </SidebarLayout>
                    </PrivateRoute>
                  }
                />
              </Routes>
          </ThemeProvider>
        </AuthProvider>
      </DashboardProvider>
    </Router>
  );
}

export default App;